export default __webpack_public_path__ + "src/assets/images/Shopping_Lists.webp";